import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Home from "../pages/Home";
import Storefront from "../pages/Storefront";

const getMarketingHosts = () => {
  const rawHosts = process.env.REACT_APP_MARKETING_HOSTS || "";
  return rawHosts
    .split(",")
    .map((host) => host.trim())
    .filter(Boolean);
};

const isMarketingHost = (host) => {
  const marketingHosts = getMarketingHosts();
  if (marketingHosts.length === 0) {
    return (
      host === "localhost" ||
      host === "127.0.0.1" ||
      host === "reflectify.co.uk" ||
      host === "www.reflectify.co.uk"
    );
  }

  return marketingHosts.includes(host);
};

const AppRoutes = () => {
  const host = window.location.hostname;
  const showMarketing = isMarketingHost(host);

  return (
    <Routes>
      <Route path="/c/:storeSlug" element={<Storefront />} />
      <Route path="/" element={showMarketing ? <Home /> : <Storefront />} />
      <Route
        path="*"
        element={showMarketing ? <Navigate to="/" replace /> : <Storefront />}
      />
    </Routes>
  );
};

export default AppRoutes;
